<form
    id="{{tool.type}}ConstructionToolForm"
    name="constructionToolForm"
    autocomplete="off"
    novalidate
    #constructionToolForm="ngForm">
    <div class="row">
        <div class="col-xs-12 mgb10 construction-tool-title">{{tool.title}}</div>

        <div class="col-xs-12 construction-tool-body">
            @if (tool.errors.length) {
                <div class="construction-tool-errors">
                    <div class="panel panel-default">
                        <div
                            class="panel-heading"
                            (click)="tool.showErrors = !tool.showErrors">
                            <span>Errors</span>
                            <span class="badge">{{tool.errors.length}}</span>
                            <i
                                class="nlrp-icon"
                                [ngClass]="tool.showErrors ? 'nlrp-icon-up-chevron' : 'nlrp-icon-down-chevron'"></i>
                        </div>
                        @if (tool.showErrors) {
                            <div class="panel-body">
                                @for (error of tool.errors; track error) {
                                    <div>{{error}}</div>
                                }
                            </div>
                        }
                    </div>
                </div>
            }

            @if (tool.warnings.length) {
                <div class="construction-tool-warnings">
                    <div class="panel panel-default">
                        <div
                            class="panel-heading"
                            (click)="tool.showWarnings = !tool.showWarnings">
                            <span>Warnings</span>
                            <span class="badge">{{tool.warnings.length}}</span>
                            <i
                                class="nlrp-icon"
                                [ngClass]="tool.showWarnings ? 'nlrp-icon-up-chevron' : 'nlrp-icon-down-chevron'"></i>
                        </div>
                        @if (tool.showWarnings) {
                            <div class="panel-body">
                                @for (warning of tool.warnings; track warning) {
                                    <div>{{warning}}</div>
                                }
                            </div>
                        }
                    </div>
                </div>
            }

            @if (tool.information.length) {
                <div class="construction-tool-information">
                    <div class="panel panel-default">
                        <div
                            class="panel-heading"
                            (click)="tool.showInformation = !tool.showInformation">
                            <span>Information</span>
                            <span class="badge">{{tool.information.length}}</span>
                            <i
                                class="nlrp-icon"
                                [ngClass]="tool.showInformation ? 'nlrp-icon-up-chevron' : 'nlrp-icon-down-chevron'"></i>
                        </div>
                        @if (tool.showInformation) {
                            <div class="panel-body">
                                @for (info of tool.information; track info) {
                                    <div>{{info}}</div>
                                }
                            </div>
                        }
                    </div>
                </div>
            }

            @for (attribute of getVisibleToolAttrs(); track attribute) {
                <div>
                    @if (attribute.attributeType === 'DOMAIN') {
                        <div [ngClass]="{'has-error': domainAttributeSelect | formFieldHasError}">
                            <label
                                class="control-label"
                                [ngClass]="{'required-input':attribute.mandatory}"
                                for="{{tool.type + attribute.prop}}">
                                {{attribute.name}}:
                            </label>
                            <div
                                class="input-group"
                                [ngClass]="{'has-error': domainAttributeSelect | formFieldHasError}">
                                <ng-select
                                    class="nlr-ng-select"
                                    [searchable]="false"
                                    [clearable]="false"
                                    [id]="tool.type + attribute.prop"
                                    [name]="tool.type + attribute.prop"
                                    [attr.name]="tool.type + attribute.prop"
                                    [title]="'Select ' + attribute.name"
                                    [disabled]="isFieldDisabled(attribute)"
                                    placeholder="Select"
                                    [items]="attribute.values"
                                    bindLabel="description"
                                    [(ngModel)]="attribute.value"
                                    (change)="attributeSelectorChanged(attribute)"
                                    [required]="attribute.mandatory"
                                    #domainAttributeSelect="ngModel">
                                </ng-select>
                            </div>
                            @if (!domainAttributeSelect.errors?.required && (domainAttributeSelect | formFieldHasError)) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>{{attribute.name}} value is invalid.</span>
                                </div>
                            }
                        </div>
                    }
                    @if (attribute.attributeType === 'BOOLEAN' && (attribute.parentAttribute === null || attribute.showBasedOnParent)) {
                        <div [ngClass]="{'has-error': booleanAttributeInput | formFieldHasError}">
                            <label
                                class="control-label"
                                [ngClass]="{'required-input':attribute.mandatory}"
                                for="{{tool.type + attribute.prop}}">
                                {{attribute.name}}:
                            </label>
                            <div
                                class="mg0"
                                title="{{attribute.name}}">
                                <span class="nlr-checkbox">
                                    <input
                                        type="checkbox"
                                        [id]="tool.type + attribute.prop"
                                        [name]="tool.type + attribute.prop"
                                        [attr.name]="tool.type + attribute.prop"
                                        [(ngModel)]="attribute.value"
                                        [required]="attribute.mandatory"
                                        (change)="attributeSelectorChanged(attribute);"
                                        [disabled]="isFieldDisabled(attribute)"
                                        #booleanAttributeInput="ngModel"
                                        tabindex="-1" />
                                    <label [for]="tool.type + attribute.prop"></label>
                                </span>
                            </div>
                            @if (!booleanAttributeInput.errors?.required && (booleanAttributeInput | formFieldHasError)) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>{{attribute.name}} value is invalid.</span>
                                </div>
                            }
                        </div>
                    }
                    <!-- TODO: show error styling on this container div when radioAttributeInput has error -->
                    @if (attribute.attributeType === 'RADIO' && (attribute.parentAttribute === null || attribute.showBasedOnParent)) {
                        <div>
                            <label
                                class="control-label"
                                [ngClass]="{'required-input': attribute.mandatory}"
                                for="{{tool.type + attribute.prop}}">
                                {{attribute.name}}:
                            </label>
                            @for (option of attribute.values; track option; let isLast = $last) {
                                <label
                                    class="nlr-radio"
                                    [ngClass]="{'has-error': radioAttributeInput | formFieldHasError}"
                                    title="Select {{attribute.name}}">
                                    <input
                                        type="radio"
                                        [id]="tool.type + attribute.prop"
                                        [name]="tool.type + attribute.prop"
                                        [attr.name]="tool.type + attribute.prop"
                                        (change)="attributeSelectorChanged(attribute)"
                                        [value]="option.value"
                                        [(ngModel)]="attribute.value"
                                        [required]="attribute.mandatory"
                                        [disabled]="isFieldDisabled(attribute)"
                                        #radioAttributeInput="ngModel" />
                                    <span>{{option.description}}</span>
                                </label>
                                @if (isLast && !radioAttributeInput.errors?.required && (radioAttributeInput | formFieldHasError)) {
                                    <div class="help-block">
                                        <span>Error!</span>
                                        <span>{{attribute.name}} value is invalid.</span>
                                    </div>
                                }
                            }
                        </div>
                    }
                    @if (
                        attribute.attributeType?.startsWith('STRING') && attribute.dms && attribute.attributeTypeLength <= 20 &&
            (attribute.parentAttribute === null || attribute.showBasedOnParent)
                    ) {
                        <div [ngClass]="{'has-error': dmsAttributeInput | formFieldHasError}">
                            <label
                                class="control-label"
                                [ngClass]="{'required-input':attribute.mandatory}"
                                for="{{tool.type + attribute.prop}}">
                                {{attribute.name}}:
                            </label>
                            <div class="input-group">
                                <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                <input
                                    autocomplete="off"
                                    type="text"
                                    class="form-control"
                                    [id]="tool.type + attribute.prop"
                                    [name]="tool.type + attribute.prop"
                                    [attr.name]="tool.type + attribute.prop"
                                    [(ngModel)]="attribute.value"
                                    [required]="attribute.mandatory"
                                    [maxLengthInputLimit]="attribute.attributeTypeLength"
                                    [placeholder]="'Enter ' + attribute.name"
                                    [title]="'Enter ' + attribute.name"
                                    nlrAnglePattern
                                    nlrFocus
                                    [nlrFocusIf]="attribute.prop === tool.defaultAttributeFocus"
                                    [disabled]="isFieldDisabled(attribute)"
                                    #dmsAttributeInput="ngModel" />
                            </div>
                            @if (!dmsAttributeInput.errors?.required && (dmsAttributeInput | formFieldHasError)) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>{{attribute.name}} value is invalid.</span>
                                </div>
                            }
                        </div>
                    }
                    @if (attribute.attributeType?.startsWith('STRING') && !attribute.dms && attribute.attributeTypeLength <= 20) {
                        <div [ngClass]="{'has-error': stringAttributeInput | formFieldHasError}">
                            <label
                                class="control-label"
                                [ngClass]="{'required-input':attribute.mandatory}"
                                for="{{tool.type + attribute.prop}}">
                                {{attribute.name}}:
                            </label>
                            <div class="input-group">
                                <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                <input
                                    type="text"
                                    class="form-control"
                                    [id]="tool.type + attribute.prop"
                                    [name]="tool.type + attribute.prop"
                                    [attr.name]="tool.type + attribute.prop"
                                    [(ngModel)]="attribute.value"
                                    [required]="attribute.mandatory"
                                    [maxLengthInputLimit]="attribute.attributeTypeLength"
                                    [placeholder]="'Enter ' + attribute.name"
                                    [title]="'Enter ' + attribute.name"
                                    autocomplete="off"
                                    nlr-uppercase="{{attribute.uppercase}}"
                                    nlrFocus
                                    [nlrFocusIf]="attribute.prop === tool.defaultAttributeFocus"
                                    [disabled]="isFieldDisabled(attribute)"
                                    #stringAttributeInput="ngModel" />
                            </div>
                            @if (!stringAttributeInput.errors?.required && (stringAttributeInput | formFieldHasError)) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>{{attribute.name}} value is invalid.</span>
                                </div>
                            }
                        </div>
                    }
                    @if (
                        (attribute.attributeType?.startsWith('STRING') && attribute.attributeTypeLength > 20) &&
            (attribute.parentAttribute === null || attribute.showBasedOnParent)
                    ) {
                        <div [ngClass]="{'has-error': stringAttributeTextarea | formFieldHasError}">
                            <label
                                class="control-label"
                                [ngClass]="{'required-input':attribute.mandatory}"
                                for="{{tool.type + attribute.prop}}_textarea">
                                {{attribute.name}}:
                            </label>
                            <div class="input-group">
                                <span class="input-group-addon corner"><i class="nlrp-icon nlrp-icon-edit corner-icon"></i></span>
                                <textarea
                                    class="form-control"
                                    [id]="tool.type + attribute.prop + '_textarea'"
                                    [name]="tool.type + attribute.prop + '_textarea'"
                                    [attr.name]="tool.type + attribute.prop + '_textarea'"
                                    [(ngModel)]="attribute.value"
                                    [required]="attribute.mandatory"
                                    [readonly]="attribute.readyOnlyBasedOnParent"
                                    [maxLengthInputLimit]="attribute.attributeTypeLength"
                                    [placeholder]="'Enter ' + attribute.name"
                                    [title]="'Enter ' + attribute.name"
                                    nlr-uppercase="{{attribute.uppercase}}"
                                    nlrFocus
                                    [nlrFocusIf]="attribute.prop === tool.defaultAttributeFocus"
                                    rows="4"
                                    [disabled]="isFieldDisabled(attribute)"
                                    #stringAttributeTextarea="ngModel">
                                </textarea>
                            </div>
                            @if (!stringAttributeTextarea.errors?.required && (stringAttributeTextarea | formFieldHasError)) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>{{attribute.name}} value is invalid.</span>
                                </div>
                            }
                        </div>
                    }
                    @if (attribute.attributeType?.includes('INTEGER')) {
                        <div [ngClass]="{'has-error': integerAttributeInput | formFieldHasError}">
                            <label
                                class="control-label"
                                [ngClass]="{'required-input':attribute.mandatory}"
                                for="{{tool.type + attribute.prop}}">
                                {{attribute.name}}:
                            </label>
                            <div class="input-group">
                                <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                <input
                                    type="number"
                                    class="form-control"
                                    [id]="tool.type + attribute.prop"
                                    [name]="tool.type + attribute.prop"
                                    [attr.name]="tool.type + attribute.prop"
                                    [(ngModel)]="attribute.value"
                                    [required]="attribute.mandatory"
                                    [pattern]="attribute.pattern"
                                    [min]="attribute.min"
                                    [max]="attribute.max"
                                    nlrp-max-length="{{('' + attribute.max).length}}"
                                    [placeholder]="'Enter ' + attribute.name"
                                    [title]="'Enter ' + attribute.name"
                                    nlrFocus
                                    [nlrFocusIf]="attribute.prop === tool.defaultAttributeFocus"
                                    [disabled]="isFieldDisabled(attribute)"
                                    #integerAttributeInput="ngModel" />
                            </div>
                            @if (!integerAttributeInput.errors?.required && (integerAttributeInput | formFieldHasError)) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>{{attribute.name}} value is invalid.</span>
                                </div>
                            }
                        </div>
                    }
                    @if (attribute.attributeType?.includes('DECIMAL')) {
                        <div [ngClass]="{'has-error': decimalAttributeInput | formFieldHasError}">
                            <label
                                class="control-label"
                                [ngClass]="{'required-input':attribute.mandatory}"
                                for="{{tool.type + attribute.prop}}">
                                {{attribute.name}}:
                            </label>
                            <div class="input-group">
                                <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                <input
                                    type="number"
                                    class="form-control"
                                    [id]="tool.type + attribute.prop"
                                    [name]="tool.type + attribute.prop"
                                    [attr.name]="tool.type + attribute.prop"
                                    [(ngModel)]="attribute.value"
                                    [required]="attribute.mandatory"
                                    [placeholder]="'Enter ' + attribute.name"
                                    [title]="'Enter ' + attribute.name"
                                    [pattern]="attribute.pattern"
                                    step="0.01"
                                    nlrFocus
                                    [nlrFocusIf]="attribute.prop === tool.defaultAttributeFocus"
                                    [disabled]="isFieldDisabled(attribute)"
                                    #decimalAttributeInput="ngModel" />
                            </div>
                            @if (!decimalAttributeInput.errors?.required && (decimalAttributeInput | formFieldHasError)) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>{{attribute.name}} value is invalid.</span>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</form>
